import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import ProductComparisonChart from '@nmx/template/dist/componentLibrary/modules/ProductComparisonChart';

export const LinkStyled = styled(Link)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      margin-top: ${mediumUp ? rem(40) : rem(32)};
    `;
  }}
`;

export const ProductComparisonChartStyled = styled(ProductComparisonChart)`
   ${({ theme }) => {
    return css`
      tfoot {
        display: none;
      }
      table {
        table-layout: fixed;
      }
      table thead th label {
        border-color: ${theme.colors.neutral.white};
        border: ${rem(1)} solid;
        overflow: hidden;
        font-size: ${rem(12)};
      }
      table thead th select {
        border: none;
        max-width: 80%
      }
      label select {
        padding: 0;
      }
    `;
  }}
`;
